import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_ORGANISATION_USERS_WITH_SAME_DOMAIN ({ commit }) {
    const query = `query organisationUsersWithSameDomain (
      $order_by: UserOrganisationSort
      $where: UserOrganisationFilter
    ) {
      organisationUsersWithSameDomain (
        order_by: $order_by
        where: $where
      ) {
        nodes{
          userId
          firstName
          lastName
          email
          isOrganisationAdmin
          isRootAdmin
        }         
      }
    }`

    const variables = {
      where: {
        isRootAdmin: false
      },
      order_by: {
        firstName: 'ASC',
        lastName: 'ASC'
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_ORGANISATION_USERS_WITH_SAME_DOMAIN', data.data.organisationUsersWithSameDomain.nodes)
    }

    return data
  },
  async GET_ORGANISATION_USERS ({ commit }) {
    const query = `query organisationUsers {
      organisationUsers {
          userId
          firstName
          lastName
          email
          isOrganisationAdmin
          isRootAdmin
      }
    }`

    const { data } = await gql({ query })

    if (!data.errors) {
      commit('SET_ORGANISATION_USERS', data.data.organisationUsers)
    }

    return data
  },
  async GET_ROOT_ORGANISATION_USER ({ commit }) {
    const query = `query organisationUsers ($where: UserOrganisationFilter) {
      organisationUsers (where: $where) {
        userId
        firstName
        lastName
        email
        phone
      }
    }`

    const variables = {
      where: {
        isRootAdmin: true
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async CREATE_ORGANISATION_USER ({ commit }, { userOrganisations }) {
    const query = `mutation userOrganisationCreate ($input: UserOrganisationCreateInput!) {
      userOrganisationCreate(input: $input) {
        userId
        firstName
        lastName
        email
        isOrganisationAdmin
      }
    }`

    const variables = {
      input: {
        userOrganisations
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async UPDATE_ORGANISATION_USER ({ commit }, { userId }) {
    const query = `mutation userOrganisationUpdate ($input: UserOrganisationUpdateInput!) {
      userOrganisationUpdate(input: $input) {
        userId
        firstName
        lastName
        email
        isOrganisationAdmin
      }
    }`

    const variables = {
      input: {
        userId
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async DELETE_ORGANISATION_USER ({ commit }, { userIds }) {
    const query = `mutation userOrganisationDelete($userIds: [Int!]) {
      userOrganisationDelete(userIds: $userIds) {
          ok
      }
    }`

    const variables = {
      userIds
    }

    const { data } = await gql({ query, variables })

    return data
  }
}
